// 产品相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
/**
 * 获取产品分类-分页
 * @param params
 * @param data
 * @returns {*}
 */
export function categoryProductPage(params,data) {
    return request({
        url: '/project/category/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 添加产品分类
 * @param data
 * @returns {*}
 */
export function addCategoryProduct(data) {
    return request({
        url: '/project/category',
        method: 'post',
        data
    })
}
/**
 * 编辑产品分类
 * @param data
 * @returns {*}
 */
export function updateCategoryProduct(data) {
    return request({
        url: '/project/category',
        method: 'put',
        data
    })
}
/**
 * 删除产品分类
 * @param id
 * @returns {*}
 */
export function delCategoryProduct(id) {
    return request({
        url: '/project/category/'+id,
        method: 'delete'
    })
}

/**
 * 所有产品分类树结构
 * @param data
 */
export function categoryProductTree(data) {
    return request({
        url: '/project/category/tree',
        method: 'post',
        data
    })
}

/**
 * 获取产品-分页
 * @param params
 * @param data
 * @returns {*}
 */
export function moduleProductPage(params,data) {
    return request({
        url: '/project/product/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 获取产品列表
 * @param categoryId
 * @returns {*}
 */
export function moduleProductList(categoryId) {
    return request({
        url: '/project/product/'+categoryId+'/list',
        method: 'get'
    })
}
/**
 * 删除产品
 * @param id
 * @returns {*}
 */
export function delModuleProduct(id) {
    return request({
        url: '/project/product/'+id,
        method: 'delete'
    })
}
/**
 * 添加产品
 * @param data
 * @returns {*}
 */
export function addModuleProduct(data) {
    return request({
        url: '/project/product',
        method: 'post',
        data
    })
}
/**
 * 编辑产品
 * @param data
 * @returns {*}
 */
export function updateModuleProduct(data) {
    return request({
        url: '/project/product',
        method: 'put',
        data
    })
}

/**
 * 产品图片上传
 * @param data
 * @param productId
 * @returns {*}
 */
export function productImg(data,productId){
    return request({
        url: '/project/product/avatar/'+productId,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
/*************P2**********************/
/**
 * 单独添加P2
 * @param data
 * @returns {*}
 */
export function addP2(data) {
    return request({
        url: '/project/product/'+data.productId+'/project2',
        method: 'post',
        data
    })
}
/**
 * 编辑P2
 * @param data
 * @returns {*}
 */
export function updateP2(data) {
    return request({
        url: '/project/product/project2',
        method: 'put',
        data
    })
}
/**
 * 根据产品id获取P2记录
 * @param productId
 * @returns {*}
 */
export function getP2(productId) {
    return request({
        url: '/project/product/'+productId+'/project2',
        method: 'get'
    })
}

/**
 * 产品和配置同时提交
 * @param data
 * @returns {*}
 */
export function saveProductAndProject2Together(data) {
    return request({
        url: '/project/product/shortcut',
        method: 'post',
        data
    })
}

/************P**************************/
/**
 * 根据产品id获取P记录
 * @param productId
 * @returns {*}
 */
export function getP(productId) {
    return request({
        url: '/project/product/'+productId+'/project',
        method: 'get'
    })
}
/**
 * 编辑P
 * @param data
 * @returns {*}
 */
export function updateP(data) {
    return request({
        url: '/project/product/project',
        method: 'put',
        data
    })
}

/************Param**************************/
/**
 * 根据产品id获取参数记录
 * @param productId
 * @returns {*}
 */
export function getParam(productId) {
    return request({
        url: '/project/product/'+productId+'/parameter',
        method: 'get'
    })
}
/**
 * 编辑参数
 * @param data
 * @returns {*}
 */
export function updateParam(data) {
    return request({
        url: '/project/product/parameter',
        method: 'put',
        data
    })
}
